export default {"src":"/a/r/be1.10/_next/static/media/map.1a39bf89.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};